module.exports = __webpack_public_path__ + "static/media/logo-icon-total-white.bc632ddb.svg";